<template lang="pug">
	
	.intro
		.intro-content.movable
			.intro-text
				p.quote {{translate('intro.bill_text')}}	
				.author 
					.text
						span.mask
						| - JOEY B4DA$$ -			
			.wrap-canvas(ref='canvas')
		

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../utils/scroller.js'
	import Ticker from '../utils/ticker.js'
	import * as PIXI from 'pixi.js'
	import Scrollable from '../abstracts/scrollable'
	import SpriteHandler from '../utils/spriteHandler'
	import _ from 'lodash'
	import Globals from '~utils/Globals'
	import AssetsLoader from '~utils/assetsLoader'

	import billSprite from 'assets/sprites/sprite.png'
	import billData from 'assets/sprites/sprite.json'

  	@Component({
		name: 'Intro',
		components: { }
	})

	class Intro extends Scrollable {

		

		mounted () {
			
			super.mounted()

			this.baseUri = process.env.NODE_ENV === "production" ? '/story/joey-bada$$-political-mc/' : '../../'
			
			this.animOffset = Globals.responsiveHeight(550)
			this.$movable = this.$el.querySelector('.movable')

		}


		init () {
			super.init()
			
			this.initSprite()
		}

		initSprite () {
			
			const wrapRect = this.$refs.canvas.getBoundingClientRect()
			this.app = new PIXI.Application(wrapRect.width,wrapRect.height,{
				transparent: true,
				antialias: false,
				resolution: 1
			})
			this.app.renderer.autoResize = true
			this.$refs.canvas.appendChild(this.app.view)

			const loader = new PIXI.loaders.Loader();

			this.spriteLoaded()

		}

		spriteLoaded (loader, resources) {

			// var spritesheet = new PIXI.Spritesheet(resources['bill'].texture.baseTexture, billData)
			var spritesheet = new PIXI.Spritesheet(new PIXI.BaseTexture(AssetsLoader.getLoadedAsset('bill').img), billData)
			
			spritesheet.parse(w => {
				this.anim = new PIXI.extras.AnimatedSprite(Object.values(spritesheet.textures))
				this.anim.width = this.app.view.width
				this.anim.height = this.app.view.height
				this.app.stage.addChild(this.anim)
			})	
		}

		_bind () {
			super._bind()
		}

		raf (y) {
			super.raf(y)

		}

		initTimeline () {
			super.initTimeline()

			let frame = {value: 0}

			const triggerOffset = Globals.responsiveHeight(450)/this.animOffset
			const billDuration = Globals.responsiveHeight(400)/this.animOffset

			this.tl.fromTo(this.$movable, 1,{y:0},{y:this.animOffset, ease:Power0.easeNone},0)
			this.tl.fromTo(frame, billDuration ,{value:0},{value:43, 
				ease: Power0.easeNone,
				onUpdate: ()=> {
					if(!this.anim) return
					let i = Math.floor(frame.value)
					this.anim.gotoAndStop(i)
				}}
			,0)
			this.tl.add(()=>{
				if(this.scroller.direction === 1) {
					TweenMax.to($(this.$el).find('.author .mask'),1.2,{x: '100%'})
				} else if(this.scroller.direction === -1) {
					TweenMax.to($(this.$el).find('.author .mask'),1.2,{x: '0%'})
				}
			},triggerOffset)
		}

		_resize () {
			super._resize()

			this.animOffset = Globals.responsiveHeight(550)
			this.bounds.height = window.innerHeight + this.animOffset
			this.$el.style.height = this.bounds.height + "px"

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.animOffset
			}

			this.initTimeline()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}
		

	}

	export default Intro

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.intro
		width 100%
		position relative
		backface-visibility hidden

		+break(xs)
			padding 0 30px

		.intro-content
			width 100%
			height 100vh
			display flex
			align-items center
			justify-content center
			position relative
			background #232323
			will-change transform

			.intro-text
				max-width 800px
				text-align center
				position relative
					
				p
					color #fff
					line-height 1em

				.quote
					font-size 60px
					font-family 'Poppins'
					font-weight 600

					+break(xs)
						font-size 30px

				.author
					width 100%
					position absolute
					left 0
					bottom -72px

					.text
						position relative
						display inline-block
						color #fff

						.mask
							position absolute
							top -4px
							right 0
							height calc(100% + 4px)
							width calc(100% + 15vw)
							background linear-gradient(to left, #232323 40%, rgba(#232323,0))

		
			.wrap-canvas
				width 1200px
				height 675px
				position absolute
				top 50%
				left calc(50% - 30px)
				transform translate3d(-50%,-50%,0)

				+break(xs)
					width 960px
					height 540px
					left 50%
				
				canvas
					width 100% !important
					height 100% !important

</style>


// WEBPACK FOOTER //
// intro.vue?134b9c5f